import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'exitView.title',
    defaultMessage: 'Sorry',
  },
  body: {
    id: 'exitView.body',
    defaultMessage: `Based on your answers, it looks like you don't qualify for the medicated weight loss programme at this time.

    If you'd like to talk to someone, have questions or need assistance, <a>https://support.babylonhealth.com/cspbabylonsupport?id=csp_sc_cat_item&table=sc_cat_item&sys_id=09cd304c8736e1101b157488dabb354d|please contact our team here</a>.

    If you think you have made an error in your responses, please click below to review your answers.

    <strong>Warning:</strong> Giving inaccurate information in a clinical consultation could put your health at risk.`,
  },
})
